import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    url: String,
    therapistProfileId: Number,
    matchResultId: { type: Number, default: 0 },
    clientIntakeId: { type: Number, default: 0 }
  };

  track(event) {
    const kind = event.params.kind;
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

    fetch(this.urlValue, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken
      },
      body: JSON.stringify({
        kind,
        therapist_profile_id: this.therapistProfileIdValue,
        match_result_id: this.matchResultIdValue || null,
        client_intake_id: this.clientIntakeIdValue || null
      }),
      keepalive: true
    }).catch(() => {});
  }
}
